var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluetooth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1715363356309,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1460,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M268.501333 328.832l60.330667-60.330667L469.333333 409.002667v-341.333334L742.997333 341.333333l-170.666666 170.666667 170.666666 170.666667L469.333333 956.330667v-341.333334l-140.501333 140.501334-60.330667-60.330667L451.669333 512 268.501333 328.832zM554.666667 750.336L622.336 682.666667 554.666667 614.997333v135.338667z m0-341.333333L622.336 341.333333 554.666667 273.664v135.338667z",
    "p-id": 1461,
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetooth);
export default __webpack_public_path__ + "static/media/bluetooth.8e1c4662ad4093cdafe80e459f907c42.svg";
export { ForwardRef as ReactComponent };